export const API_PATH_apiUsersInvitationsPut = '/services/users-invitations';
